"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WizardStepContext = void 0;

var React = _interopRequireWildcard(require("react"));

var WizardStepContext = /*#__PURE__*/React.createContext({
  index: 0,
  status: "disabled",
  nextStepStatus: "disabled",
  isCompact: false,
  isActive: false,
  onChangeStep: function onChangeStep() {}
});
exports.WizardStepContext = WizardStepContext;